module.exports = __webpack_public_path__ + "media/images/home/focus-bg4-2d78dc9ad67d805729150fa04aa770e1.png";